import { render, staticRenderFns } from "./document-card.vue?vue&type=template&id=b442c274&scoped=true&"
import script from "./document-card.vue?vue&type=script&lang=js&"
export * from "./document-card.vue?vue&type=script&lang=js&"
import style0 from "./document-card.vue?vue&type=style&index=0&id=b442c274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b442c274",
  null
  
)

export default component.exports